import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Grid, Typography, Chip, Box } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import {
  ContactIcon,
  HelpGrid,
  HeroHelp,
  HeroTitle,
  ItemCard,
  SearchInput,
  MainContent,
} from "Modules/Core/Help/Help.styled";
import helpPageCards from "Modules/Core/Help/HelpContent";
import { Link } from "react-router-dom";
import { ResourceFooter } from "Modules/Marketing/Resources/ResourceFooter";
import { ShTextFieldV2 } from "shared/SharedStyles/ShInputs";
import { CommonQuestionSidebar } from "./CommonQuestionSidebar";

interface ItemProps {
  title: string;
  description: string;
  category: string;
}

export const Help = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchQuery(event.target.value);
  };

  const categories = Array.from(new Set(helpPageCards.map(card => card.category)));

  const filteredCards = helpPageCards.filter(
    (card) =>
      (card.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        card.desc.toLowerCase().includes(searchQuery.toLowerCase())) &&
      (!selectedCategory || card.category === selectedCategory)
  );

  const Item = ({ title, description, category }: ItemProps) => {
    return (
      <ItemCard>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Typography variant="h6" sx={{ flex: 1 }}>
            {title}
          </Typography>
          <Chip 
            label={category} 
            size="small" 
            sx={{ 
              backgroundColor: 'primary.light',
              color: 'white',
              fontWeight: 500,
              fontSize: '0.75rem'
            }} 
          />
        </Box>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {description}
        </Typography>
      </ItemCard>
    );
  };

  return (
    <>
      <HeroHelp>
        <HeroTitle>How Can We Help?</HeroTitle>
        <SearchInput>
          <ShTextFieldV2
            placeholder="Search for answers"
            variant="standard"
            value={searchQuery}
            onChange={handleSearchInputChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </SearchInput>
      </HeroHelp>
      <HelpGrid>
        <MainContent>
          <Box sx={{ mb: 3, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Chip 
              label="All" 
              onClick={() => setSelectedCategory(null)}
              color={selectedCategory === null ? "primary" : "default"}
              sx={{ mr: 1 }}
            />
            {categories.map((category) => (
              <Chip
                key={category}
                label={category}
                onClick={() => setSelectedCategory(category)}
                color={selectedCategory === category ? "primary" : "default"}
              />
            ))}
          </Box>
          <Grid container spacing={3}>
            {filteredCards.map((card, id) => (
              <Grid key={id} item xs={12} md={6} lg={4}>
                <Link to={card.path} style={{ textDecoration: "none" }}>
                  <Item title={card.title} description={card.desc} category={card.category} />
                </Link>
              </Grid>
            ))}
          </Grid>
        </MainContent>
        <CommonQuestionSidebar />
      </HelpGrid>
      <ResourceFooter />
      <ContactIcon>
        {/* To Do In Future */}
        {/* <Fab color="primary" aria-label="contact" style={{ padding: '26px 0' }}>
          <ChatOutlinedIcon />
        </Fab> */}
      </ContactIcon>
    </>
  );
};
